<app-smartsupp [username]="smartsuppUsername" alignX="right"></app-smartsupp>

<div class="container" >
  <div class="login-top-logo"></div>

  <div class="login-container">
    <div class="row no-gutters">
      <div class="col-6 d-flex flex-column p-3">
        <h3 class="title mb-5"><span>RSM-ONLINE</span>CLASSROOM DIAGNOSTICS</h3>
        <p class="font-size-12">Please sign in with your first and last name:</p>

        <!--suppress AngularUndefinedBinding -->
        <form (ngSubmit)="creatNewGuest($event)" ngNativeValidate>
          <div class="form-group">
            <label for="inputName" class="sr-only">Your name</label>
            <input [(ngModel)]="guestName" type="text" id="inputName" name="name" class="form-control" placeholder="Your name" required autofocus>
          </div>
          <div class="form-group text-right">
            <button class="btn btn-primary" type="submit">Sign in</button>
          </div>
        </form>

        <div class="bottom-links font-size-14 mt-auto">
          <div>
            <a href="../../../../../static/VirtualClassroomGuide.html" target="_blank">Virtual Classroom Guide<span class="far fa-angle-right ml-2"></span></a>
          </div>
        </div>
      </div>
      <div class="col-6 login-right-img"></div>
    </div>
  </div>
</div>
